import $ from 'jquery';

function initContestOrganizerAdminsEdit() {
  const editForm = document.querySelector('.contest-organizer-edit');

  if (!editForm) {
    return;
  }

  const adminCheckBox = editForm.querySelector('[name="admin"]');

  if (!adminCheckBox) {
    return;
  }

  adminCheckBox.addEventListener('change',  async function (e) {
    if (!e.target.checked) {
      return;
    }

    e.preventDefault();

    const modalSelector = '#paid-settings-modal[data-event-source-id="administrator-checkbox"]';
    const paidSettingsModal = document.querySelector(modalSelector);

    if (!paidSettingsModal) {
      adminCheckBox.checked = false;

      return false;
    }

    const url  = paidSettingsModal.getAttribute('data-check-contest-paid-url');

    const response = await fetch(url);
    const result = await response.json();

    if (result.status === 'success') {
      return true;
    } else {
      const overlay = $('#overlay');
      overlay.addClass('cabinet-contest-modal');
      overlay.fadeIn();
      paidSettingsModal.classList.add('active');
      adminCheckBox.checked = false;

      return false;
    }
  });
}

export { initContestOrganizerAdminsEdit }